import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./Components/Layout";
import Home from "./Components/Home";

import RefundPage from "./Components/RefundAndCancellatioon/RefundPage";
import PrivacyPolicyPage from "./Components/RefundAndCancellatioon/PrivacyPolicyPage";
import TermsConditionsPage from "./Components/RefundAndCancellatioon/TermsConditionsPage";

import AboutPage from "./Components/aboutPage/AboutPage";
import RetailerPage from "./Components/retailerPage/RetailerPage";
import Pricing from "./Components/PricingPage/Pricing";
import FAQSection from "./Components/FaqPage/FaqSection";

import BillPayments from "./Components/ProductBillPayments/BillPayments";
import IncomeCalculator from "./Components/IncomeCalculator/IncomeCalculator";

import ScrollToTop from "./Components/common/ScrollToTop";

import AnalyticsPage from "./Components/AnalyticsPage/AnalyticsPage";
import VendorApkDownloader from "./Components/vendorApkDownloader/VendorApkDownloader";
import "./App.css";
import ContactPage from "./Components/contact/ContactPage";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        <Route path="/vendor_apk_download" element={<VendorApkDownloader />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="retailer" element={<RetailerPage />} />
          <Route path="pricing" element={<Pricing />} />

          <Route path="product">
            <Route path="bill-payment" element={<BillPayments />} />
            <Route path="income-calculator" element={<IncomeCalculator />} />
            <Route path="analytics" element={<AnalyticsPage />} />
          </Route>

          <Route path="faq" element={<FAQSection />} />
          <Route path="refund" element={<RefundPage />} />
          <Route path="privacy" element={<PrivacyPolicyPage />} />
          <Route path="terms" element={<TermsConditionsPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
